import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { AdvanceInvoiceModel } from 'src/app/models/invoicing/advance-invoice.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdvanceInvoiceService {

  private readonly _httpClient = inject(HttpClient);

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAdvanceInvoiceById(advanceInvoiceId: number): Observable<AdvanceInvoiceModel> {
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetByIdAsync}/${advanceInvoiceId}`);
  }

  getAdvanceInvoiceByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<AdvanceInvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetAdvanceInvoiceByKeys}`, { params: params });
  }

  getAllAdvanceInvoicesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetAllAdvanceInvoicesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstAdvanceInvoiceByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number): Observable<AdvanceInvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetFirstAdvanceInvoiceByKeys}`, { params: params });
  }

  getLastAdvanceInvoiceByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number): Observable<AdvanceInvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetLastAdvanceInvoiceByKeys}`, { params: params });
  }

  getPreviusAdvanceInvoiceByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<AdvanceInvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetPreviusAdvanceInvoiceByKeys}`, { params: params });
  }

  getNextAdvanceInvoiceByKeysAsync(branchId: number, enterpriseId: number, bussinessDocumentsTypeId: number, consecutive: number): Observable<AdvanceInvoiceModel> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    params = params.set('enterpriseId', enterpriseId);
    params = params.set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    params = params.set('consecutive', consecutive);
    return this._httpClient.get<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.GetNextAdvanceInvoiceByKeys}`, { params: params });
  }

  setStateAdvanceInvoice(invoiceId: number): Observable<AdvanceInvoiceModel> {
    return this._httpClient.put<AdvanceInvoiceModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.advanceInvoice.SetAdvanceInvoiceStateAsync}/${invoiceId}`,
      null);
  }

}
